import { isValid, parseISO } from 'date-fns';
import { IntlShape } from 'react-intl';

const CURRENT_YEAR = new Date().getFullYear();

const parseDateValue = (dateValue: string) => {
  const parsedDate = parseISO(dateValue);
  if (isValid(parsedDate)) {
    return parsedDate;
  }

  return new Date(dateValue);
};

export const formatDate = (
  intl: IntlShape,
  dateValue: string,
  displayedOnSummary = false
) => {
  const date = parseDateValue(dateValue);
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  };
  if (date.getFullYear() !== CURRENT_YEAR || displayedOnSummary) {
    options.year = 'numeric';
  }
  return intl.formatDate(date, options);
};
